import React from 'react';
import { useForm } from 'react-hook-form';
import { useCampaignsStore } from '../../stores/useDataStore';

const CreateCampaignModal = ({ isOpen, onClose, pageId, pageModel, modalData }) => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const createCampaign = useCampaignsStore((state) => state.createCampaign);

  const resolvedPageId = pageId || modalData?.pageId;
  const resolvedPageModel = pageModel || modalData?.pageModel;

  const onSubmit = async (data) => {
    const campaignData = {
      ...data,
      pageId: resolvedPageId,
      pageModel: resolvedPageModel,
    };
    const success = await createCampaign(campaignData);
    if (success) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center p-4" onClick={onClose}>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="p-6">
          <h2 className="text-xl font-bold mb-4">Nueva Campaña</h2>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium">Nombre de la Campaña</label>
              <input type="text" id="name" {...register('name', { required: 'El nombre es obligatorio' })} className="mt-1 w-full p-2 border rounded-md dark:bg-gray-700" />
              {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name.message}</p>}
            </div>
            <div>
              <label htmlFor="objective" className="block text-sm font-medium">Objetivo Principal</label>
              <select id="objective" {...register('objective', { required: 'Debes seleccionar un objetivo' })} className="mt-1 w-full p-2 border rounded-md dark:bg-gray-700 bg-white">
                <option value="">Selecciona un objetivo...</option>
                <option value="brand_awareness">Reconocimiento de Marca</option>
                <option value="traffic">Tráfico al Sitio Web</option>
                <option value="sales">Ventas de Productos</option>
              </select>
              {errors.objective && <p className="text-red-500 text-xs mt-1">{errors.objective.message}</p>}
            </div>
            <div>
              <label htmlFor="budget" className="block text-sm font-medium">Presupuesto (USD)</label>
              <input type="number" id="budget" step="0.01" {...register('budget', { required: 'El presupuesto es obligatorio', valueAsNumber: true, min: { value: 1, message: 'El presupuesto debe ser al menos $1.00' } })} className="mt-1 w-full p-2 border rounded-md dark:bg-gray-700" />
              {errors.budget && <p className="text-red-500 text-xs mt-1">{errors.budget.message}</p>}
            </div>
            <div className="pt-4 flex justify-end gap-3">
              <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-semibold rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700">
                Cancelar
              </button>
              <button type="submit" disabled={isSubmitting} className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 disabled:bg-blue-300 font-semibold">
                {isSubmitting ? 'Creando...' : 'Crear Campaña'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateCampaignModal;